export const cardDinmenions = { width: 420, height: 280, minimumCadsInViewport: 4, marginRight: 25 }
export const textColor = 0xff8be0cb
